import React, { useState, useEffect } from "react";
import { usersRestaurantCHK, getUser } from "../api/users";
import { Me } from "../api/users";
import { PostGet } from "../api/post";
import {
  addShift,
  addInternShift,
  DeleteShift,
  AddForeignShift,
} from "../api/shift";
import { OpentypeShiftGet } from "../api/type_shift";
import { addOpenShift } from "../api/shift";
import { GetRestaurants } from "../api/restaurant";
import {
  getSchedule,
  GetScheduleDays,
  GetScheduleAboutShifts,
} from "../api/schedule_chk";

import { FreeTS } from "../api/template_shift";
import { GetApprove, Approve } from "../api/approved_chk";
import { GetReportCHK } from "../api/report";
import { DirectorLevel, TYLevel, HRLevel, ApprovedStatusId, MngGroupLevels } from "../constants";
import { createServiceNote } from "../api/service_note";

const DAY_LABELS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

const ScheduleChk = ({ token }) => {
  const [accessLevelUser, setAccessLevelUser] = useState();
  const [currentUser, setCurrentUser] = useState();

  const [arrayDate, setArrayDate] = useState(
    getFormattedWeekDates(new Date().toISOString().split("T")[0]),
  );

  // DAY
  const [selectedDayUser, setSelectedDayUser] = useState(null);
  const [selectedWeekday, setSelectedWeekday] = useState(null);
  const [selectedShiftDay, setSelectedShiftDay] = useState(null);
  const [showAddFromDay, setShowAddFromDay] = useState(null);
  const [selectedTypeShift, setSelectedTypeShift] = useState("");
  const [modalMessageDay, setModalMessageDay] = useState("");
  const [dataScheduleDays, setDataScheduleDays] = useState(null);
  const [selectedInternUser, setSelectedInternUser] = useState(null);
  // EndDAY

  // Grafic
  const [graficScheduleTables, setGraficSchedulTables] = useState([]);
  const [dataGraficSchedule, setDataGraficSchedule] = useState(null);
  const [selectedTemplateShift, setSelectedTemplateShift] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const [selectedDateGrafic, setSelectedDateGrafic] = useState(null);
  const [showAddFormGrafic, setAddFormGrafic] = useState(false);
  const [selectedGraficUser, setSelectedGraficUser] = useState(0);
  const [modalMessageGrafic, setModalMessageGrafic] = useState("");
  const [graficModalTab, setGraficModalTab] = useState("create");
  const [serviceNoteComment, setServiceNoteComment] = useState("");
  const [replaceEmployeeId, setReplaceEmployeeId] = useState(0);
  const [swapTemplateShiftId, setSwapTemplateShiftId] = useState(0);

  // EndGrafic

  // AboutShift

  const [dataAboutShift, setDataAboutShift] = useState(null);
  const [tableAboutShift, setTableAboutShift] = useState("");

  // EndAboutShift

  const [openTypeShift, setOpenTypeShift] = useState([]);
  const [loadScheduleDay, setLoadScheduleDay] = useState(false);
  const [userModal, setUserModal] = useState([]);

  const [nameOpenShift, setNameOpenShift] = useState("");
  const [ScheduleCHKDays, setScheduleCHKDays] = useState([]);
  //////////////
  const [startDate, setStartDate] = useState(
    getWeekRange(new Date().toISOString().split("T")[0])["monday"],
  );
  const [endDate, setEndDate] = useState(
    getWeekRange(new Date().toISOString().split("T")[0])["sunday"],
  );
  const [loadGraficTables, setLoadGraficTables] = useState(null);

  ///////////

  const [dataApprove, setDataApprove] = useState();
  const [tableApprove, setTableApprove] = useState();
  const [userApprove, setUserApprove] = useState({
    status_id: "1",
    comment: "",
  });

  ///
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(0);
  const [selectedUserForeign, setSelectedUserForeign] = useState(0);
  const [selectedDateForeign, setSelectedDateForeign] = useState("");
  const [dataFreeTS, setDataFreeTS] = useState([]);
  const [selectedFreeTS, setSelectedFreeTS] = useState(0);
  const [foreignMessage, setForeignMessage] = useState("");

  const [startDateDownload, setStartDateDownload] = useState();
  const [endDateDownload, setEndDateDownload] = useState();
  const [approveMessage, setApproveMessage] = useState("");

  const [activeTab, setActiveTab] = useState("days");
  const [isLoadingDays, setIsLoadingDays] = useState(false);
  const [isLoadingGrafic, setIsLoadingGrafic] = useState(false);
  const [isLoadingSummary, setIsLoadingSummary] = useState(false);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [weekPickerDate, setWeekPickerDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const loadTypeShift = async () => {
    try {
      const data = await GetRestaurants(token, 1, 50);
      setRestaurants(data.data);
      const response = await OpentypeShiftGet(token);
      const OpenTypeShiftMap = Object.fromEntries(
        response.map((shift) => [shift.id, shift.name]),
      );
      setNameOpenShift(OpenTypeShiftMap);
      setOpenTypeShift(response);
      const nowUser = await Me(token);
      setCurrentUser(nowUser);
      const post = await PostGet(token, nowUser.post_id);
      setAccessLevelUser(post.access_level);

      const usersRestaurantNow = await usersRestaurantCHK(
        token,
        nowUser.restaurant_id,
      );
      setUserModal(usersRestaurantNow);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadTypeShift();
  }, [token]);

  useEffect(() => {
    if (token) {
      scheduleDay();
    }
  }, [token]);

  useEffect(() => {
    if (currentUser && dataScheduleDays) {
      ScheduleDaysRender(dataScheduleDays);
    }
  }, [currentUser, dataScheduleDays, openTypeShift, arrayDate]);

  useEffect(() => {
    if (currentUser && dataGraficSchedule) {
      renderGrafic(dataGraficSchedule);
    }
  }, [currentUser, dataGraficSchedule, userModal]);

  useEffect(() => {
    if (currentUser && dataAboutShift) {
      renderAboutShift(dataAboutShift);
    }
  }, [currentUser, dataAboutShift, userModal]);

  function getOwnEmployeeIds() {
    if (!currentUser?.restaurant_id) return null;
    return new Set(
      userModal
        .filter((u) => u.restaurant_id === currentUser.restaurant_id)
        .map((u) => u.id),
    );
  }

  function filterScheduleDaysForRestaurant(data, restaurantId) {
    if (!Array.isArray(data) || !restaurantId) return data;
    return data.filter((row) => row[7]?.restaurant_id === restaurantId);
  }

  function filterShiftsForOwnEmployees(shifts, ownEmployeeIds) {
    if (!Array.isArray(shifts) || !ownEmployeeIds?.size) return shifts;
    return shifts.filter((s) => ownEmployeeIds.has(s.employee));
  }

  function filterUsersForRestaurant(users, restaurantId) {
    if (!Array.isArray(users) || !restaurantId) return users;
    return users.filter((u) => u.restaurant_id === restaurantId);
  }

  function switchTab(tab) {
    setActiveTab(tab);
    if (tab === "days" && !loadScheduleDay) scheduleDay();
    if (tab === "grafic" && !loadGraficTables) graficSchedule();
    if (tab === "summary" && !dataAboutShift) loadScheduleAboutShfit();
    if (tab === "approve" && !dataApprove) loadAppored();
  }

  async function selectDateDay(event) {
    const date = event.target.value;
    setWeekPickerDate(date);
    const selectDateInput = new Date(event.target.value);
    setArrayDate(getFormattedWeekDates(selectDateInput));
    setLoadScheduleDay(false);
    setLoadGraficTables(false);
    setDataAboutShift(null);
    setTableAboutShift("");
    setDataApprove(undefined);
    setTableApprove(undefined);
    const dates = getWeekRange(date);

    setStartDate(dates["monday"]);
    setEndDate(dates["sunday"]);

    const weekDates = getFormattedWeekDates(selectDateInput);
    if (activeTab === "days") {
      scheduleDay(weekDates[0], weekDates.at(-1));
    } else if (activeTab === "grafic") {
      graficSchedule(dates["monday"], dates["sunday"]);
    } else if (activeTab === "summary") {
      loadScheduleAboutShfit(weekDates[0], weekDates.at(-1));
    } else if (activeTab === "approve") {
      loadAppored(weekDates[0], weekDates.at(-1));
    }
  }

  async function selectDay(event, user, weekday, show, shift) {
    setSelectedDayUser(user);
    setSelectedWeekday(weekday);
    setShowAddFromDay(show);
    setSelectedShiftDay(shift);
    setModalMessageDay("");
  }

  async function ScheduleDaysRender(data) {
    const filtered = filterScheduleDaysForRestaurant(
      data,
      currentUser?.restaurant_id,
    );
    let tbody = [];
    let rows = [];
    for (let userShifts in filtered) {
      let user = filtered[userShifts][7];
      const isFT = filtered[userShifts].length == 9;
      // Тут пробегаем по пользователю (тут список смен по дням)
      // от 0 до 6, а data[7] - пользователь
      let weekShifts = [];
      for (let i = 0; i <= 6; i++) {
        // Т.к. у сотрудника может быть несколько смен в один день
        // Нужно пройтись циклом по дню
        let dayShifts = [];
        for (let shift of filtered[userShifts][i]) {
          dayShifts.push(shift);
        }
        weekShifts.push(dayShifts);
      }
      tbody.push(
        <tr key={`user_${user.id}`}>
          <td className="schedule-chk-employee">
            <div className="employee-name">
              {user.surname} {user.name}
              {isFT && (
                <span className="badge bg-secondary ms-1" style={{ fontSize: "0.7rem" }}>
                  FT
                </span>
              )}
            </div>
            <small className="text-muted">{user.post_name}</small>
          </td>

          {weekShifts.map((day, key) => renderShiftDay(day, user, key))}
        </tr>,
      );
      rows.push(weekShifts);
    }
    setScheduleCHKDays(tbody);
  }

  function getShiftCellClass(day) {
    if (day.length === 0) return "shift-cell--off";
    for (let s of day) {
      const typeId = Number(s.type_shift_id);
      if (typeId === 2) return "shift-cell--intern";
      if (typeId === 3) return "shift-cell--foreign";
      if (typeId !== 1) return "shift-cell--open";
    }
    return "shift-cell--regular";
  }

  function renderShiftDay(day, user, weekday) {
    const cellClass = getShiftCellClass(day);
    const openModal = (show, shift) => (e) => {
      selectDay(e.stopPropagation(), user, weekday, show, shift);
      if (show) getFreeTSForDay(weekday);
    };

    if (day.length == 0) {
      return (
        <td key={weekday} className={`shift-cell text-center ${cellClass}`}>
          <div
            className="shift-cell-clickable"
            data-bs-toggle="modal"
            data-bs-target="#ScheduleDayModal"
            onClick={openModal(true, null)}
          >
            Выходной
          </div>
        </td>
      );
    }

    return (
      <td key={weekday} className={`shift-cell text-center ${cellClass}`}>
        {day.map((shift) => {
          let content;
          if (shift.type_shift_id == 2) {
            content = (
              <>
                Закр. за {shift.fix_employee_surname} {shift.fix_employee_name}{" "}
                {shift.start} - {shift.end} {shift.station_name}
              </>
            );
          } else if (shift.type_shift_id == 1) {
            content = `${shift.start} - ${shift.end} ${shift.station_name}`;
          } else if (shift.type_shift_id == 3) {
            content = `${shift.start} - ${shift.end} ${shift.station_name}. В ${shift.restaurant_name}`;
          } else {
            content = shift.type_shift_name;
          }
          return (
            <div
              key={shift.id}
              className="shift-cell-clickable"
              data-bs-toggle="modal"
              data-bs-target="#ScheduleDayModal"
              onClick={openModal(false, shift)}
            >
              {content}
            </div>
          );
        })}
      </td>
    );
  }

  async function scheduleDay(overrideFrom, overrideTo) {
    const from = overrideFrom ?? arrayDate[0];
    const to = overrideTo ?? arrayDate.at(-1);
    if (!from) {
      alert("Выберите дату!");
      return;
    }
    if (!overrideFrom && (loadScheduleDay || isLoadingDays)) return;
    setIsLoadingDays(true);
    try {
      const scheduleDays = await GetScheduleDays(token, from, to);
      setDataScheduleDays(scheduleDays);
      ScheduleDaysRender(scheduleDays);
      setLoadScheduleDay(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingDays(false);
    }
  }

  async function addShiftOpenScheduleDay(event) {
    const data = await addOpenShift(
      token,
      arrayDate[selectedWeekday],
      selectedDayUser.id,
      selectedTypeShift,
    );
    if (data.detail) {
      setModalMessageDay(<p style={{ color: "red" }}> {data.detail}</p>);
      return;
    }
    const updateDataScheduleDays = dataScheduleDays.map((userShifts) => {
      const user = userShifts[7]; // Получаем объект пользователя
      if (user.id == selectedDayUser.id) {
        // Создаем копию всего массива смен пользователя
        const newUserShifts = [...userShifts];

        // Получаем массив смен для выбранного дня (если он есть)
        const existingShifts = newUserShifts[selectedWeekday] || [];

        // Создаем НОВЫЙ массив смен: старые + новая смена
        newUserShifts[selectedWeekday] = [
          ...existingShifts, // Все существующие смены этого дня
          data, // Добавляем новую смену
        ];

        return newUserShifts;
      }
      return [...userShifts];
    });

    setDataScheduleDays(updateDataScheduleDays);
    ScheduleDaysRender(updateDataScheduleDays);
    setShowAddFromDay(false);
    setSelectedShiftDay(data);

    const user = await getUser(token, data.employee);
    setModalMessageDay(
      <p style={{ color: "green" }}>
        Сотрудник {user.surname} {user.name} записан на {data.date} на{" "}
        {nameOpenShift[data.type_shift_id]}
      </p>,
    );
  }

  async function addInternShiftScheduleDay(event) {
    const data = await addInternShift(
      token,
      arrayDate[selectedWeekday],
      selectedDayUser.id,
      selectedInternUser,
    );
    console.log(data, "createInternShift");
    if (data.detail) {
      setModalMessageDay(<p style={{ color: "red" }}> {data.detail}</p>);
      return;
    }
    const employee = await getUser(token, data[0].employee);
    const fixUser = await getUser(token, data[0].fix_employee);

    const updateDataScheduleDays = dataScheduleDays.map((userShifts) => {
      const user = userShifts[7]; // Получаем объект пользователя
      if (user.id == selectedDayUser.id) {
        // Создаем копию всего массива смен пользователя
        const newUserShifts = [...userShifts];

        // Получаем массив смен для выбранного дня (если он есть)
        const existingShifts = newUserShifts[selectedWeekday] || [];

        // Создаем НОВЫЙ массив смен: старые + новая смена
        newUserShifts[selectedWeekday] = [
          ...existingShifts, // Все существующие смены этого дня
          ...data, // Добавляем новую смену
        ];

        return newUserShifts;
      }
      return [...userShifts];
    });

    if (dataGraficSchedule) {
      // 1. Создаем новый массив с добавленной сменой
      const updatedShifts = [...dataGraficSchedule.shifts, ...data];

      // 2. Создаем новый объект с обновленным массивом
      const updatedSchedule = {
        ...dataGraficSchedule,
        shifts: updatedShifts,
      };

      // 3. Обновляем состояние
      setDataGraficSchedule(updatedSchedule);

      // 4. Перерисовываем график с новыми данными
      renderGrafic(updatedSchedule);
    }

    if (dataAboutShift) {
      const updatedData = {
        ...dataAboutShift, // Копируем все существующие поля
        shifts: [...dataAboutShift.shifts, ...data], // Создаем новый массив смен
      };
      setDataAboutShift(updatedData);
      renderAboutShift(updatedData);
    }

    setShowAddFromDay(false);
    setSelectedShiftDay(data);
    setDataScheduleDays(updateDataScheduleDays);
    ScheduleDaysRender(updateDataScheduleDays);
    setModalMessageDay(
      <p style={{ color: "green" }}>
        Сотрудник {employee.surname} {employee.name} закреплен на {data[0].date}{" "}
        за {fixUser.surname} {fixUser.name}
      </p>,
    );
  }

  async function deleteShiftScheduleChk(event) {
    if (!selectedShiftDay) {
      setModalMessageDay(<p style={{ color: "red" }}>Нечего удалять!</p>);
      return;
    }

    const data = await DeleteShift(token, selectedShiftDay.id);
    if (data.detail) {
      setModalMessageDay(<p style={{ color: "red" }}> {data.detail}</p>);
      return;
    }
    //
    console.log(selectedWeekday);
    await getFreeTSForDay(selectedWeekday);
    let showAddform = true;
    const updateDataScheduleDays = dataScheduleDays.map((userShifts) => {
      const user = userShifts[7]; // Получаем объект пользователя

      if (user.id == selectedDayUser.id) {
        // Создаем копию всего массива смен пользователя
        const newUserShifts = [...userShifts];

        // Получаем массив смен для выбранного дня
        const existingShifts = newUserShifts[selectedWeekday] || [];

        // Фильтруем массив: оставляем все смены, КРОМЕ той, которую нужно удалить
        newUserShifts[selectedWeekday] = existingShifts.filter(
          (shift) => shift.id !== selectedShiftDay.id,
        );
        if (newUserShifts[selectedWeekday].length !== 0) {
          showAddform = false;
        }

        return newUserShifts;
      }

      // Для других пользователей возвращаем копию
      return [...userShifts];
    });

    if (dataGraficSchedule) {
      const currentSchedule = { ...dataGraficSchedule };

      // Фильтруем смены
      const updatedShifts = currentSchedule.shifts.filter(
        (shift) => shift.id !== selectedShiftDay.id,
      );

      // Создаем обновленный объект
      const updatedSchedule = {
        ...currentSchedule,
        shifts: updatedShifts,
      };

      // Перерисовываем график
      renderGrafic(updatedSchedule);

      // Устанавливаем новое состояние
      setDataGraficSchedule(updatedSchedule);
    }

    if (dataAboutShift) {
      const updatedData = {
        ...dataAboutShift, // Копируем все существующие поля
        shifts: dataAboutShift.shifts.filter(
          (shift) => shift.id !== selectedShiftDay.id,
        ),
        // Оставляем только смены, у которых ID НЕ равен удаляемому
      };

      setDataAboutShift(updatedData);
      renderAboutShift(updatedData);
    }

    setDataScheduleDays(updateDataScheduleDays);
    ScheduleDaysRender(updateDataScheduleDays);

    setShowAddFromDay(showAddform);
    setSelectedShiftDay(null);
    setModalMessageDay(<p style={{ color: "green" }}>Удалено!</p>);
  }

  async function graficSchedule(overrideStart, overrideEnd) {
    const start = overrideStart ?? startDate;
    const end = overrideEnd ?? endDate;
    if (!start) {
      alert("Выберите дату!");
      return;
    }
    if (!overrideStart && (loadGraficTables || isLoadingGrafic)) return;
    setIsLoadingGrafic(true);
    try {
      const [data, approveData] = await Promise.all([
        getSchedule(token, start, end),
        GetApprove(token, start, end),
      ]);
      setDataGraficSchedule(data);
      if (approveData && !approveData.detail) {
        setDataApprove(approveData);
      }
      renderGrafic(data);
      setLoadGraficTables(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingGrafic(false);
    }
  }

  async function addShiftGrafic(event) {
    if (!selectedGraficUser) {
      setModalMessageGrafic(
        <p style={{ color: "red" }}>Не выбран сотрудник!</p>,
      );
      return;
    }

    const newShift = await addShift(
      token,
      selectedTemplateShift.id,
      selectedGraficUser,
    );
    if (newShift.detail) {
      setModalMessageGrafic(<p style={{ color: "red" }}>{newShift.detail}</p>);
      return;
    }
    setModalMessageGrafic("");
    // 1. Создаем новый массив с добавленной сменой
    const updatedShifts = [...dataGraficSchedule.shifts, newShift];

    // 2. Создаем новый объект с обновленным массивом
    const updatedSchedule = {
      ...dataGraficSchedule,
      shifts: updatedShifts,
    };

    // 3. Обновляем состояние
    setDataGraficSchedule(updatedSchedule);

    // 4. Перерисовываем график с новыми данными
    renderGrafic(updatedSchedule);
    // setDataGraficSchedule(dataGraficSchedule);
    setSelectedShift(newShift);
    setAddFormGrafic(false);

    const selectedWeekday = getISODayNumber(newShift.date);
    if (dataScheduleDays) {
      // console.log(dataScheduleDays, newShift);

      const updateDataScheduleDays = dataScheduleDays.map((userShifts) => {
        const user = userShifts[7]; // Получаем объект пользователя

        if (user.id == newShift.employee) {
          // Создаем копию всего массива смен пользователя
          const newUserShifts = [...userShifts];

          // Получаем массив смен для выбранного дня (если он есть)
          const existingShifts = newUserShifts[selectedWeekday] || [];

          // Создаем НОВЫЙ массив смен: старые + новая смена
          newUserShifts[selectedWeekday] = [
            ...existingShifts, // Все существующие смены этого дня
            newShift, // Добавляем новую смену
          ];

          return newUserShifts;
        }
        return [...userShifts];
      });

      setDataScheduleDays(updateDataScheduleDays);
      ScheduleDaysRender(updateDataScheduleDays);
    }

    if (dataAboutShift) {
      console.log(dataAboutShift);
      const updatedData = {
        ...dataAboutShift, // Копируем все существующие поля
        shifts: [...dataAboutShift.shifts, newShift], // Создаем новый массив смен
      };
      setDataAboutShift(updatedData);
      renderAboutShift(updatedData);
    }
  }

  async function deleteShiftGrafic(event) {
    if (!selectedShift) {
      setModalMessageGrafic(
        <p style={{ color: "red" }}>Нет смены, чтобы удалить!</p>,
      );
      return;
    }
    const deleteShift = await DeleteShift(token, selectedShift.id);

    console.log("Удаление смены:", deleteShift);

    if (deleteShift.detail) {
      setModalMessageGrafic(
        <p style={{ color: "red" }}>{deleteShift.detail}</p>,
      );
      return;
    }
    setModalMessageGrafic("");

    const currentSchedule = { ...dataGraficSchedule };
    // Фильтруем смены
    const updatedShifts = currentSchedule.shifts.filter(
      (shift) => shift.id !== selectedShift.id,
    );

    // Создаем обновленный объект
    const updatedSchedule = {
      ...currentSchedule,
      shifts: updatedShifts,
    };

    console.log(currentSchedule, updatedShifts, updatedSchedule);

    // Перерисовываем график
    renderGrafic(updatedSchedule);

    // Устанавливаем новое состояние
    setDataGraficSchedule(updatedSchedule);
    const selectedWeekday = getISODayNumber(selectedShift.date);
    if (dataScheduleDays) {
      const updateDataScheduleDays = dataScheduleDays.map((userShifts) => {
        const user = userShifts[7]; // Получаем объект пользователя

        if (user.id == selectedShift.employee) {
          // Создаем копию всего массива смен пользователя
          const newUserShifts = [...userShifts];

          // Получаем массив смен для выбранного дня
          const existingShifts = newUserShifts[selectedWeekday] || [];

          // Фильтруем массив: оставляем все смены, КРОМЕ той, которую нужно удалить
          newUserShifts[selectedWeekday] = existingShifts.filter(
            (shift) => shift.id !== selectedShift.id,
          );

          return newUserShifts;
        }

        // Для других пользователей возвращаем копию
        return [...userShifts];
      });

      setDataScheduleDays(updateDataScheduleDays);
      ScheduleDaysRender(updateDataScheduleDays);
    }

    if (dataAboutShift) {
      const updatedData = {
        ...dataAboutShift, // Копируем все существующие поля
        shifts: dataAboutShift.shifts.filter(
          (shift) => shift.id !== selectedShift.id,
        ),
        // Оставляем только смены, у которых ID НЕ равен удаляемому
      };

      setDataAboutShift(updatedData);
      renderAboutShift(updatedData);
    }
    setSelectedShift(null);
    setAddFormGrafic(true);
  }

  function selectFieldGrafic(templateShift, shift, date) {
    console.log("Выбранный шаблон и смена", templateShift, shift);
    setModalMessageGrafic("");
    setServiceNoteComment("");
    setReplaceEmployeeId(0);
    setSwapTemplateShiftId(0);
    if (shift) {
      setAddFormGrafic(false);
      setGraficModalTab("delete");
    } else {
      setAddFormGrafic(true);
      setGraficModalTab("create");
    }
    setSelectedTemplateShift(templateShift);
    setSelectedShift(shift);
    setSelectedDateGrafic(date);
  }

  const isScheduleTyApproved = dataApprove?.TY_status === ApprovedStatusId;
  const canManageSchedule = MngGroupLevels.includes(Number(accessLevelUser));
  const useServiceNoteFlow = isScheduleTyApproved && canManageSchedule;

  function getSwapShiftOptions() {
    if (!dataGraficSchedule?.ts || !dataGraficSchedule?.shifts || !selectedTemplateShift) {
      return [];
    }
    return dataGraficSchedule.ts
      .filter((ts) => ts.id !== selectedTemplateShift.id)
      .map((ts) => {
        const shift = dataGraficSchedule.shifts.find(
          (s) => s.template_shift_id === ts.id,
        );
        if (!shift) return null;
        return { templateShift: ts, shift };
      })
      .filter(Boolean);
  }

  function buildShiftSnapshot(shift, templateShift) {
    return {
      shift_id: shift?.id ?? null,
      template_shift_id: templateShift?.id ?? shift?.template_shift_id,
      employee_id: shift?.employee ?? null,
      employee_name: shift
        ? `${shift.user_surname ?? ""} ${shift.user_name ?? ""}`.trim()
        : null,
      date: templateShift?.date ?? shift?.date,
      station_name: templateShift?.station_name ?? shift?.station_name,
      start: templateShift?.start ?? shift?.start,
      end: templateShift?.end ?? shift?.end,
    };
  }

  async function submitServiceNoteGrafic() {
    if (!serviceNoteComment.trim()) {
      setModalMessageGrafic(
        <p style={{ color: "red" }}>Укажите причину изменения в комментарии</p>,
      );
      return;
    }

    let operationType = null;
    let templateShiftId = selectedTemplateShift?.id ?? null;
    let secondTemplateShiftId = null;
    let payload = { snapshot: {}, comment: serviceNoteComment.trim() };

    if (graficModalTab === "create") {
      if (!selectedGraficUser || selectedGraficUser === "0") {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите сотрудника для записи</p>,
        );
        return;
      }
      operationType = "create_shift";
      const selectedEmployee = userModal.find(
        (user) => user.id === Number(selectedGraficUser),
      );
      const employeeName = selectedEmployee
        ? `${selectedEmployee.surname} ${selectedEmployee.name}`.trim()
        : null;
      payload.employee_id = Number(selectedGraficUser);
      payload.snapshot = {
        template_shift: buildShiftSnapshot(null, selectedTemplateShift),
        employee_id: Number(selectedGraficUser),
        employee_name: employeeName,
      };
    } else if (graficModalTab === "delete") {
      if (!selectedShift) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Нет смены для удаления</p>,
        );
        return;
      }
      operationType = "delete_shift";
      payload.snapshot = buildShiftSnapshot(selectedShift, selectedTemplateShift);
    } else if (graficModalTab === "replace") {
      if (!selectedShift) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Нет смены для замены сотрудника</p>,
        );
        return;
      }
      if (!replaceEmployeeId || replaceEmployeeId === "0") {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите нового сотрудника</p>,
        );
        return;
      }
      if (Number(replaceEmployeeId) === selectedShift.employee) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите другого сотрудника</p>,
        );
        return;
      }
      operationType = "replace_employee";
      const newEmployee = userModal.find(
        (user) => user.id === Number(replaceEmployeeId),
      );
      const newEmployeeName = newEmployee
        ? `${newEmployee.surname} ${newEmployee.name}`.trim()
        : null;
      payload.new_employee_id = Number(replaceEmployeeId);
      payload.snapshot = {
        shift: buildShiftSnapshot(selectedShift, selectedTemplateShift),
        new_employee_id: Number(replaceEmployeeId),
        new_employee_name: newEmployeeName,
      };
    } else if (graficModalTab === "swap") {
      if (!selectedShift) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите смену для обмена</p>,
        );
        return;
      }
      if (!swapTemplateShiftId || swapTemplateShiftId === "0") {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите вторую смену для обмена</p>,
        );
        return;
      }
      const swapOption = getSwapShiftOptions().find(
        (opt) => String(opt.templateShift.id) === String(swapTemplateShiftId),
      );
      if (!swapOption) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Вторая смена недоступна для обмена</p>,
        );
        return;
      }
      operationType = "swap_employees";
      secondTemplateShiftId = swapOption.templateShift.id;
      payload.snapshot = {
        shift_a: buildShiftSnapshot(selectedShift, selectedTemplateShift),
        shift_b: buildShiftSnapshot(swapOption.shift, swapOption.templateShift),
      };
    }

    const body = {
      start_date: startDate,
      end_date: endDate,
      comment: serviceNoteComment.trim(),
      operation: {
        operation_type: operationType,
        template_shift_id: templateShiftId,
        second_template_shift_id: secondTemplateShiftId,
        payload,
      },
    };

    const result = await createServiceNote(token, body);
    if (result.detail) {
      setModalMessageGrafic(<p style={{ color: "red" }}>{result.detail}</p>);
      return;
    }
    setModalMessageGrafic(
      <p style={{ color: "green" }}>Служебная записка отправлена на согласование</p>,
    );
  }

  async function handleGraficModalSubmit(event) {
    if (useServiceNoteFlow) {
      await submitServiceNoteGrafic();
      return;
    }
    if (graficModalTab === "create") {
      await addShiftGrafic(event);
      return;
    }
    if (graficModalTab === "delete") {
      await deleteShiftGrafic(event);
      return;
    }
    setModalMessageGrafic(
      <p style={{ color: "red" }}>
        Замена и обмен доступны после согласования расписания ТУ через служебную
        записку
      </p>,
    );
  }

  function renderGraficModalTabContent() {
    const slotInfo = selectedTemplateShift
      ? getInfoTemplateShiftGrafic(selectedTemplateShift)
      : "";
    const shiftInfo = selectedShift ? (
      <>
        <p className="mb-1">
          Сотрудник: <b>{getInfoFromShiftGrafic(selectedShift)}</b>
        </p>
        <p className="mb-0">{getInfoShiftGrafic(selectedShift)}</p>
      </>
    ) : null;

    if (graficModalTab === "create") {
      return (
        <div className="schedule-grafic-tab-panel">
          <p className="schedule-chk-modal-info text-center">{slotInfo}</p>
          <select
            className="form-select mx-auto"
            style={{ maxWidth: "400px" }}
            value={selectedGraficUser}
            onChange={(e) => setSelectedGraficUser(e.target.value)}
            disabled={!!selectedShift}
          >
            <option value="0">Выберите сотрудника для записи</option>
            {userModal.map((user) => (
              <option key={user.id} value={user.id}>
                {user.surname} {user.name}
              </option>
            ))}
          </select>
          {selectedShift && (
            <p className="text-muted small text-center mt-2">
              На этот слот уже назначена смена — используйте другую вкладку
            </p>
          )}
        </div>
      );
    }

    if (graficModalTab === "delete") {
      return (
        <div className="schedule-grafic-tab-panel schedule-chk-modal-info text-center">
          {shiftInfo || (
            <p className="text-muted">Смена не выбрана или слот пустой</p>
          )}
          {useServiceNoteFlow && selectedShift && (
            <p className="text-warning small mt-2">
              Будет создана служебная записка на удаление смены
            </p>
          )}
        </div>
      );
    }

    if (graficModalTab === "replace") {
      return (
        <div className="schedule-grafic-tab-panel">
          <div className="schedule-chk-modal-info text-center mb-3">
            {shiftInfo || (
              <p className="text-muted">Выберите занятый слот в расписании</p>
            )}
          </div>
          <select
            className="form-select mx-auto"
            style={{ maxWidth: "400px" }}
            value={replaceEmployeeId}
            onChange={(e) => setReplaceEmployeeId(e.target.value)}
            disabled={!selectedShift}
          >
            <option value="0">Новый сотрудник на смену</option>
            {userModal
              .filter((user) => user.id !== selectedShift?.employee)
              .map((user) => (
                <option key={user.id} value={user.id}>
                  {user.surname} {user.name}
                </option>
              ))}
          </select>
        </div>
      );
    }

    if (graficModalTab === "swap") {
      const swapOptions = getSwapShiftOptions();
      return (
        <div className="schedule-grafic-tab-panel">
          <div className="schedule-chk-modal-info text-center mb-3">
            <p className="mb-1">
              <b>Смена A:</b> {getInfoFromShiftGrafic(selectedShift) || "—"}
            </p>
            <p className="mb-0 small text-muted">{slotInfo}</p>
          </div>
          <select
            className="form-select mx-auto"
            style={{ maxWidth: "420px" }}
            value={swapTemplateShiftId}
            onChange={(e) => setSwapTemplateShiftId(e.target.value)}
            disabled={!selectedShift}
          >
            <option value="0">Смена B для обмена</option>
            {swapOptions.map(({ templateShift, shift }) => (
              <option key={templateShift.id} value={templateShift.id}>
                {shift.user_surname} {shift.user_name} — {templateShift.station_name}{" "}
                ({templateShift.start}-{templateShift.end})
              </option>
            ))}
          </select>
          {selectedShift && swapOptions.length === 0 && (
            <p className="text-muted small text-center mt-2">
              Нет других занятых слотов для обмена в этой неделе
            </p>
          )}
        </div>
      );
    }

    return null;
  }

  function getGraficModalSubmitLabel() {
    if (useServiceNoteFlow) {
      return "Отправить служебную записку";
    }
    if (graficModalTab === "delete") {
      return "Удалить запись";
    }
    return "Записать";
  }

  function isGraficModalSubmitDisabled() {
    if (graficModalTab === "create") {
      return !!selectedShift;
    }
    if (graficModalTab === "delete" || graficModalTab === "replace") {
      return !selectedShift;
    }
    if (graficModalTab === "swap") {
      return !selectedShift || getSwapShiftOptions().length === 0;
    }
    return false;
  }

  async function renderGrafic(data) {
    const templateShifts = data.ts;
    // Все смены ресторана (включая пришедших из других ресторанов) — бэкенд уже
    // фильтрует по restaurant_id; не ограничиваем список «своими» сотрудниками.
    const shifts = data.shifts;
    const info = data.info;
    const ofd = data.ofd;
    let previosNightTS = []; // Шаблоны, которые начинаются и заканчиваются в разный день
    let tables = [];
    let body = [];

    let ts_day_count = 0;
    let ts_day_hours = 0;
    let shifts_day_count = 0;
    let shifts_day_hours = 0;

    let ts_divided = {};
    let shifts_divided = {};
    let ofd_divided = {};

    for (let hour of ofd) {
      const day = new Date(hour.hour).toISOString().split("T")[0];
      if (!ofd_divided[day]) {
        ofd_divided[day] = [];
      }
      ofd_divided[day].push(hour);
    }
    console.log(ofd_divided);

    const date = new Date(arrayDate[0]);
    date.setDate(date.getDate() - 1);
    const previousDay = date.toISOString().split("T")[0]; // '2025-09-14'
    let lastDate = previousDay;

    for (let index in templateShifts) {
      let templateShift = templateShifts[index];
      if (templateShift.date == previousDay) {
        let end = templateShift.end;
        if (end == 0) {
          end = 24;
          if (
            templateShift.start > templateShift.end &&
            templateShift.end > 0
          ) {
            previosNightTS.push(templateShift);
          }
        }

        continue;
      }
      if (templateShift.date in ts_divided) {
        ts_divided[templateShift.date].push(templateShift);
      } else {
        ts_divided[templateShift.date] = [templateShift];
      }
    }

    for (let index in shifts) {
      let shift = shifts[index];
      if (shift.date in shifts_divided) {
        shifts_divided[shift.date].push(shift);
      } else {
        shifts_divided[shift.date] = [shift];
      }
    }

    let has_night_shift_in_last_sunday = false;
    if (has_night_shift_in_last_sunday == false) {
      for (let date in ts_divided) {
        ts_day_count = 0;
        ts_day_hours = 0;
        shifts_day_count = 0;
        shifts_day_hours = 0;

        let startGroup = true;
        body = [];
        let previos_now = previosNightTS;
        previosNightTS = [];
        let previos_ts_sorted = previos_now.sort((a, b) =>
          a.group_station_name.localeCompare(b.group_station_name),
        );
        let previosGrouped = previos_ts_sorted.reduce((groups, ts) => {
          const key = ts.group_station_name;
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(ts);
          return groups;
        }, {});

        for (let group in previosGrouped) {
          previosGrouped[group].sort((a, b) => a.start - b.start);
        }

        let ts_date = ts_divided[date];
        let ord_ts_date = ts_date.sort((a, b) =>
          a.group_station_name.localeCompare(b.group_station_name),
        );
        let grouped = ord_ts_date.reduce((groups, ts) => {
          const key = ts.group_station_name;
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(ts);
          return groups;
        }, {});
        for (let group in grouped) {
          grouped[group].sort((a, b) => a.start - b.start);
        }
        // console.log(previosGrouped, "prev");

        for (let groupName in grouped) {
          let group = grouped[groupName];
          startGroup = true;
          let prevGroup = previosGrouped[groupName];
          if (prevGroup) {
            for (let indexTS in prevGroup) {
              let templateShift = prevGroup[indexTS];
              // ts_day_count += 1;
              // ts_day_hours += templateShift.hours;

              let start = 0;
              let end = 24 - templateShift.end;
              let hours = templateShift.end;
              let shifts = findShift(
                shifts_divided,
                lastDate,
                templateShift.id,
              );

              for (let shift of shifts) {
                let rowspan = prevGroup.length + group.length;
                if (startGroup) {
                  for (let ts of prevGroup) {
                    let shiftsHere = findShift(shifts_divided, lastDate, ts.id);
                    if (shiftsHere.length > 0) {
                      rowspan += shiftsHere.length - 1;
                    }
                  }
                  for (let ts of group) {
                    let shiftsHere = findShift(shifts_divided, date, ts.id);
                    if (shiftsHere.length > 0) {
                      rowspan += shiftsHere.length - 1;
                    }
                  }
                }
                body.push(
                  pushShiftTbody(
                    templateShift,
                    shift,
                    date,
                    startGroup,
                    rowspan,
                    groupName,
                    start,
                    hours,
                    end,
                    "night",
                  ),
                );
                startGroup = false;
              }
              if (shifts.length == 0) {
                let rowspan = prevGroup.length + group.length;
                if (startGroup) {
                  for (let ts of prevGroup) {
                    let shiftsHere = findShift(shifts_divided, lastDate, ts.id);
                    if (shiftsHere.length > 0) {
                      rowspan += shiftsHere.length - 1;
                    }
                  }
                  for (let ts of group) {
                    let shiftsHere = findShift(shifts_divided, date, ts.id);
                    if (shiftsHere.length > 0) {
                      rowspan += shiftsHere.length - 1;
                    }
                  }
                }
                body.push(
                  pushTemplateShiftTbody(
                    templateShift,
                    date,
                    startGroup,
                    rowspan,
                    groupName,
                    start,
                    hours,
                    end,
                    "night",
                  ),
                );
              }
              startGroup = false;
            }
          }

          for (let indexTS in group) {
            let templateShift = group[indexTS];
            let start = templateShift.start;
            let end = templateShift.end;
            ts_day_hours += templateShift.hours;
            if (end == 0) {
              end = 24;
            }
            let hours = 0;
            if (end > templateShift.start) {
              end = 24 - end;
              hours = templateShift.hours;
            } else if (templateShift.end > 0) {
              previosNightTS.push(templateShift);
              end = 0;
              hours = 24 - start;
            }

            let shifts = findShift(shifts_divided, date, templateShift.id);
            for (let shift of shifts) {
              if (shift.hours) {
                shifts_day_hours += shift.hours;
              }

              let rowspan = group.length;
              if (startGroup) {
                for (let ts of group) {
                  let shiftsHere = findShift(shifts_divided, date, ts.id);
                  if (shiftsHere.length > 0) {
                    rowspan += shiftsHere.length - 1;
                  }
                }
              }
              body.push(
                pushShiftTbody(
                  templateShift,
                  shift,
                  date,
                  startGroup,
                  rowspan,
                  groupName,
                  start,
                  hours,
                  end,
                  "day",
                ),
              );
              startGroup = false;
            }

            if (shifts.length == 0) {
              let rowspan = group.length;
              if (startGroup) {
                for (let ts of group) {
                  let shiftsHere = findShift(shifts_divided, date, ts.id);
                  if (shiftsHere.length > 0) {
                    rowspan += shiftsHere.length - 1;
                  }
                }
              }
              body.push(
                pushTemplateShiftTbody(
                  templateShift,
                  date,
                  startGroup,
                  // group.length,
                  rowspan,
                  groupName,
                  start,
                  hours,
                  end,
                  "day",
                ),
              );
            }

            startGroup = false;
          }
        }
        let FactSPMH = 0; // TO / hours
        let PlanSPMH = 0; // TO / hours
        let FactTCPH = 0; // receipt / hours
        let PlanTCPH = 0; // receipt / hours
        let receiptsOFD = 0;
        let cashOFD = 0;

        let TOData = null;

        for (let to of info) {
          if (to && to.date == date) {
            console.log(ofd_divided[date]);

            TOData = to;
            if (ts_day_hours > 0) {
              PlanSPMH = (TOData.value / ts_day_hours).toFixed(3);
              PlanTCPH = (TOData.receipt / ts_day_hours).toFixed(3);
            }
            if (shifts_day_hours > 0) {
              FactSPMH = (TOData.value / shifts_day_hours).toFixed(3);
              FactTCPH = (TOData.receipt / shifts_day_hours).toFixed(3);
            }
            break;
          }
        }

        for (let hour in ofd_divided[date]) {
          receiptsOFD += ofd_divided[date][hour].receipts;
          cashOFD += ofd_divided[date][hour].cash;
        }

        if (!TOData) {
          TOData = {};
          TOData.value = "Нет в бд";
          TOData.receipt = "Нет в бд";
        }
        tables.push(
          <div className="table-gragic" key={date}>
            <p className="text-center">
              Дата: {date}. День недели: {getRussianWeekday(date)}.
            </p>
            <div className="col-md-6 offset-md-3">
              <table className="table table-bordered text-center table-sm">
                <thead>
                  <tr>
                    <th></th>
                    <th>ТО</th>
                    <th>Транзакции</th>
                    <th>SPMH</th>
                    <th>TCPH</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>План</td>
                    <td>{TOData.value}</td>
                    <td>{TOData.receipt}</td>
                    <td>{PlanSPMH}</td>
                    <td>{PlanTCPH}</td>
                  </tr>
                  <tr>
                    <td>Факт</td>
                    <td>{cashOFD}</td>
                    <td>{receiptsOFD}</td>
                    <td>{FactSPMH}</td>
                    <td>{FactTCPH}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* <table className="table table-bordered table-striped"> */}
            <div className="table-responsive">
            <table className="table table-bordered text-center grafic-table schedule-chk-table">
              <thead>
                <tr>
                  <th scope="col">Группа</th>
                  <th scope="col">Позиция</th>
                  <th scope="col">Сотрудник</th>
                  <th scope="col">С По</th>
                  {/* Добавляем заголовки от 0 до 23 */}
                  {Array.from({ length: 24 }, (_, i) => (
                    <th key={i} className="text-center" scope="col">
                      {i}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>{body}</tbody>
            </table>
            </div>
          </div>,
        );
        lastDate = date;
      }
    }

    setGraficSchedulTables(tables);
  }

  function findShift(shfits, date, templateShiftId) {
    const shifts = shfits[date];
    let needShifts = [];
    if (!shifts) return [];
    for (let shift of shifts) {
      if (shift.template_shift_id == templateShiftId) {
        needShifts.push(shift);
      }
    }
    return needShifts;
  }

  function getInfoShiftGrafic(shift) {
    if (shift) {
      return `${shift.start} - ${shift.end} ${shift.station_name} ${
        shift.date
      }. ${getRussianWeekday(shift.date)}. В ресторане ${shift.restaurant_name}`;
    }
  }

  function getInfoTemplateShiftGrafic(templateShift) {
    console.log(templateShift, "выбранный шаблон смены");
    if (templateShift) {
      return `${templateShift.start} - ${templateShift.end} ${
        templateShift.station_name
      } ${templateShift.date}. ${getRussianWeekday(templateShift.date)}`;
    }
  }

  function getInfoFromShiftGrafic(shift) {
    if (shift) {
      // return `${shift.user_surname} ${shift.user_name} ${shift.user_post_name}`;
      return `${shift.user_surname} ${shift.user_name}. `;
    }
  }

  async function loadAppored(overrideFrom, overrideTo) {
    const from = overrideFrom ?? arrayDate[0];
    const to = overrideTo ?? arrayDate.at(-1);
    if (!from) return;
    if (!overrideFrom && isLoadingApprove) return;
    setIsLoadingApprove(true);
    try {
      const data = await GetApprove(token, from, to);
      setDataApprove(data);
      setTableApprove(renderApprove(data));
      if (accessLevelUser == HRLevel) {
        userApprove["comment"] = data["HR_comment"];
        userApprove["comment"] = data["HR_status"];
      } else if (accessLevelUser == TYLevel) {
        userApprove["comment"] = data["TY_comment"];
        userApprove["status_id"] = data["TY_status"];
      } else if (accessLevelUser == DirectorLevel) {
        userApprove["comment"] = data["director_comment"];
        userApprove["status_id"] = data["director_status"];
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingApprove(false);
    }
  }

  function getApproveBadgeClass(status) {
    if (status == null || status == 1) return "bg-danger";
    if (status == 2) return "bg-warning text-dark";
    if (status == 3) return "bg-success";
    return "bg-secondary";
  }

  function renderApprove(data) {
    const statusTextById = {
      1: "Не согласовано",
      2: "На доработке",
      3: "Согласовано!",
    };
    return (
      <table className="table table-bordered schedule-chk-table">
        <thead>
          <tr className="text-center">
            <th>Директор</th>
            <th>Территориальный управляющий</th>
            <th>HR-менеджер</th>
          </tr>
        </thead>
        <tbody>
          <tr className="text-center">
            <td>
              <span className={`badge ${getApproveBadgeClass(data.director_status)}`}>
                {statusTextById[data.director_status] || "—"}
              </span>
            </td>
            <td>
              <span className={`badge ${getApproveBadgeClass(data.TY_status)}`}>
                {statusTextById[data.TY_status] || "—"}
              </span>
            </td>
            <td>
              <span className={`badge ${getApproveBadgeClass(data.HR_status)}`}>
                {statusTextById[data.HR_status] || "—"}
              </span>
            </td>
          </tr>
          <tr className="text-center">
            <td>{data.director_surname_name}</td>
            <td>{data.TY_surname_name}</td>
            <td>{data.HR_surname_name}</td>
          </tr>
          <tr>
            <td className="text-muted small">{data.director_comment || "—"}</td>
            <td className="text-muted small">{data.TY_comment || "—"}</td>
            <td className="text-muted small">{data.HR_comment || "—"}</td>
          </tr>
          <tr>
            <td
              className="text-center schedule-chk-approve-btn"
              colSpan={3}
              data-bs-toggle="modal"
              data-bs-target="#approvalModal"
            >
              Изменить статус согласования
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  function selectStageApprove(event) {
    setUserApprove({ ...userApprove, status_id: event.target.value });
  }

  function onChangeCommentApprove(event) {
    setUserApprove({ ...userApprove, comment: event.target.value });
  }

  async function approveSchedule(event) {
    if (arrayDate.length == 0) {
      setApproveMessage(<p style={{ color: "red" }}>Не выбрана дата!</p>);
      setUserApprove({
        status_id: "1",
        comment: "",
      });
      return;
    }
    console.log(userApprove)
    const data = await Approve(
      token,
      arrayDate[0],
      arrayDate.at(-1),
      userApprove["status_id"]?? 1,
      userApprove["comment"] ?? "",
    );
    if (data.detail) {
      setApproveMessage(<p style={{ color: "red" }}>{data.detail}</p>);
      setUserApprove({
        status_id: "1",
        comment: "",
      });
      return;
    }
    setApproveMessage(<p style={{ color: "green" }}>Успешно!</p>);
    setTableApprove(renderApprove(data));
  }

  async function getFreeTS(event) {
    if (selectedRestaurant == 0) {
      setForeignMessage(<p style={{ color: "red" }}>Выберите ресторан!</p>);
      return;
    }
    if (selectedDateForeign == "") {
      setForeignMessage(<p style={{ color: "red" }}>Выберите дату!</p>);
      return;
    }
    const data = await FreeTS(token, selectedRestaurant, selectedDateForeign);
    if (data.detail) {
      setForeignMessage(<p style={{ color: "red" }}>{data.detail}</p>);
      return;
    } else {
      setForeignMessage(<p style={{ color: "green" }}>Выгружено!</p>);
    }
    setDataFreeTS(data);
    console.log(data);
  }

  async function recordForeignShift(event) {
    console.log(selectedFreeTS, selectedUserForeign);
    const data = await AddForeignShift(
      token,
      selectedFreeTS,
      selectedUserForeign,
    );
    if (data.detail) {
      setForeignMessage(<p style={{ color: "red" }}>{data.detail}</p>);
      return;
    } else {
      setForeignMessage(<p style={{ color: "green" }}>Успешно!</p>);
    }
    console.log(data);
  }

  async function download() {
    const response = await GetReportCHK(
      token,
      startDateDownload,
      endDateDownload,
    );
    console.log(response);

    // Получаем blob из данных ответа axios
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Создание URL для blob
    const url = window.URL.createObjectURL(blob);

    // Создание временной ссылки для скачивания
    const link = document.createElement("a");
    link.href = url;

    // Получение имени файла из headers
    const contentDisposition = response.headers["content-disposition"];
    let filename = "food_report.xlsx";

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    link.download = filename;

    // Автоматическое скачивание
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Очистка URL
    window.URL.revokeObjectURL(url);
  }

  async function loadScheduleAboutShfit(overrideFrom, overrideTo) {
    const from = overrideFrom ?? arrayDate[0];
    const to = overrideTo ?? arrayDate.at(-1);
    if (!from) return;
    if (!overrideFrom && isLoadingSummary) return;
    setIsLoadingSummary(true);
    try {
      const data = await GetScheduleAboutShifts(token, from, to);
      setDataAboutShift(data);
      renderAboutShift(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingSummary(false);
    }
  }

  function renderAboutShift(data) {
    const ownEmployeeIds = getOwnEmployeeIds();
    const shifts = filterShiftsForOwnEmployees(data.shifts, ownEmployeeIds);
    const users = filterUsersForRestaurant(
      data.users,
      currentUser?.restaurant_id,
    );
    let body = [];

    for (let user of users) {
      let shiftCount = 0;
      let shiftHours = 0;
      let shiftBKHours = 0;
      let differentHours = 0;
      for (let shift of shifts) {
        if (
          new Set([1, 2, 3]).has(shift.type_shift_id) &&
          shift.employee == user.id
        ) {
          shiftCount += 1;
          shiftHours += shift.hours;
          // if (shift.bk_hours && shift.bk_night_hours) {
          //   shiftBKHours += calculateTimeDiff();
          // }
          console.log(shift);
        }
      }
      // console.log(getInfoUser(user));
      body.push(
        <tr key={`about_${user.id}`}>
          <td>{getInfoUser(user)}</td>
          <td>{shiftCount}</td>
          <td>{shiftHours}</td>
          <td>{shiftBKHours}</td>
          <td>{shiftBKHours - shiftHours}</td>
        </tr>,
      );
    }

    setTableAboutShift(
      <table className="table table-bordered text-center schedule-chk-table table-hover">
        <thead>
          <tr>
            <th scope="col">Сотрудник</th>
            <th scope="col">Кол-во смен</th>
            <th scope="col">Запланированно часов</th>
            <th scope="col">Отработано времени</th>
            <th scope="col">Разница часов</th>
          </tr>
        </thead>
        <tbody>{body}</tbody>
      </table>,
    );
  }

  async function getFreeTSForDay(week) {
    if (!currentUser?.restaurant_id) return;
    const freeTSForDay = await FreeTS(
      token,
      currentUser.restaurant_id,
      arrayDate[week],
    );
    setDataFreeTS(freeTSForDay);
  }

  async function createShiftDayByTS(params) {
    if (parseInt(selectedFreeTS) === 0) {
      setModalMessageDay(
        <p style={{ color: "red" }}> Не выбран шаблон смены для сотрудника</p>,
      );
      return;
    }
    console.log(selectedFreeTS, selectedDayUser);
    const newShift = await addShift(token, selectedFreeTS, selectedDayUser.id);
    if (newShift.detail) {
      setModalMessageDay(<p style={{ color: "red" }}>{newShift.detail}</p>);
      return;
    }
    const updateDataScheduleDays = dataScheduleDays.map((userShifts) => {
      const user = userShifts[7]; // Получаем объект пользователя
      if (user.id === selectedDayUser.id) {
        // Создаем копию всего массива смен пользователя
        const newUserShifts = [...userShifts];

        // Получаем массив смен для выбранного дня (если он есть)
        const existingShifts = newUserShifts[selectedWeekday] || [];

        // Создаем НОВЫЙ массив смен: старые + новая смена
        newUserShifts[selectedWeekday] = [
          ...existingShifts, // Все существующие смены этого дня
          newShift, // Добавляем новую смену
        ];

        return newUserShifts;
      }
      return [...userShifts];
    });
    setDataScheduleDays(updateDataScheduleDays);
    ScheduleDaysRender(updateDataScheduleDays);

    if (dataGraficSchedule) {
      // 1. Создаем новый массив с добавленной сменой
      const updatedShifts = [...dataGraficSchedule.shifts, newShift];

      // 2. Создаем новый объект с обновленным массивом
      const updatedSchedule = {
        ...dataGraficSchedule,
        shifts: updatedShifts,
      };

      // 3. Обновляем состояние
      setDataGraficSchedule(updatedSchedule);

      // 4. Перерисовываем график с новыми данными
      renderGrafic(updatedSchedule);
    }

    if (dataAboutShift) {
      const updatedData = {
        ...dataAboutShift, // Копируем все существующие поля
        shifts: [...dataAboutShift.shifts, newShift], // Создаем новый массив смен
      };
      setDataAboutShift(updatedData);
      renderAboutShift(updatedData);
    }

    setModalMessageDay(<p style={{ color: "green" }}> Успешно!</p>);
    setSelectedFreeTS(0);
    setSelectedShiftDay(newShift);
    const newDataTS = dataFreeTS.filter(
      (ts) => ts.id !== newShift.template_shift_id,
    );

    setDataFreeTS(newDataTS);
    setShowAddFromDay(false);
    // console.log(dataFreeTS.filter)
  }

  const renderLoading = () => (
    <div className="text-center py-5">
      <div
        className="spinner-border"
        style={{ color: "#fd0429" }}
        role="status"
      >
        <span className="visually-hidden">Загрузка...</span>
      </div>
      <p className="text-muted mt-2 mb-0">Загрузка...</p>
    </div>
  );

  return (
    <div className="schedule-chk-page">
      <div className="schedule-chk-toolbar">
        <div>
          <h1>Расписание ЧК</h1>
          <p className="schedule-chk-hint">
            Выберите любой день — загрузится неделя с понедельника по воскресенье
          </p>
        </div>
        <div className="schedule-chk-week-picker">
          <input
            type="date"
            className="form-control"
            value={weekPickerDate}
            onChange={selectDateDay}
          />
          <span className="schedule-chk-week-range">
            {startDate} — {endDate}
          </span>
        </div>
      </div>

      <ul className="nav nav-tabs schedule-chk-tabs mb-3">
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "days" ? "active" : ""}`}
            onClick={() => switchTab("days")}
          >
            По дням
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "grafic" ? "active" : ""}`}
            onClick={() => switchTab("grafic")}
          >
            График
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "summary" ? "active" : ""}`}
            onClick={() => switchTab("summary")}
          >
            Сводка
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "approve" ? "active" : ""}`}
            onClick={() => switchTab("approve")}
          >
            Согласование
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "more" ? "active" : ""}`}
            onClick={() => switchTab("more")}
          >
            Прочее
          </button>
        </li>
      </ul>

      <div className="schedule-chk-panel">
        {activeTab === "days" && (
          <>
            {isLoadingDays ? (
              renderLoading()
            ) : ScheduleCHKDays.length === 0 ? (
              <div className="schedule-chk-empty">Нет данных за выбранную неделю</div>
            ) : (
              <>
                <div className="schedule-chk-legend">
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--off" />
                    Выходной
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--regular" />
                    Смена
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--intern" />
                    Закрепление
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--foreign" />
                    Другой ресторан
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--open" />
                    Статус дня
                  </span>
                </div>
              <div className="table-responsive">
                <table className="table table-bordered table-hover schedule-chk-table">
                  <thead>
                    <tr>
                      <th className="text-center" scope="col">
                        Сотрудник
                      </th>
                      {DAY_LABELS.map((label, i) => (
                        <th key={label} className="text-center" scope="col">
                          {label}
                          {arrayDate[i] && (
                            <span className="day-header-date">
                              {formatShortDate(arrayDate[i])}
                            </span>
                          )}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>{ScheduleCHKDays.map((row) => row)}</tbody>
                </table>
              </div>
              </>
            )}
          </>
        )}

        {activeTab === "grafic" && (
          <>
            {isLoadingGrafic ? (
              renderLoading()
            ) : graficScheduleTables.length === 0 ? (
              <div className="schedule-chk-empty">
                Нет графика за выбранную неделю
              </div>
            ) : (
              graficScheduleTables.map((table) => table)
            )}
          </>
        )}

        {activeTab === "summary" && (
          <>
            {isLoadingSummary ? (
              renderLoading()
            ) : !tableAboutShift ? (
              <div className="schedule-chk-empty">
                Нет сводки за выбранную неделю
              </div>
            ) : (
              <div className="table-responsive">{tableAboutShift}</div>
            )}
          </>
        )}

        {activeTab === "approve" && (
          <>
            {isLoadingApprove ? (
              renderLoading()
            ) : !tableApprove ? (
              <div className="schedule-chk-empty">
                Нет данных о согласовании за выбранную неделю
              </div>
            ) : (
              <div className="table-responsive">{tableApprove}</div>
            )}
          </>
        )}

        {activeTab === "more" && (
          <>
            <h5 className="mb-3">Смена в другом ресторане</h5>
            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <label htmlFor="foreign-restaurant" className="form-label">
                  Ресторан
                </label>
                <select
                  className="form-select"
                  id="foreign-restaurant"
                  value={selectedRestaurant}
                  onChange={(e) => setSelectedRestaurant(e.target.value)}
                >
                  <option value={0}>Не выбрано</option>
                  {restaurants.map((rest) => (
                    <option value={rest.id} key={rest.id}>
                      {rest.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="foreign-user" className="form-label">
                  Сотрудник
                </label>
                <select
                  className="form-select"
                  id="foreign-user"
                  value={selectedUserForeign}
                  onChange={(e) => setSelectedUserForeign(e.target.value)}
                >
                  <option value={0}>Не выбрано</option>
                  {userModal.map((user) => (
                    <option value={user.id} key={user.id}>
                      {user.surname} {user.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="foreign-date" className="form-label">
                  Дата
                </label>
                <input
                  className="form-control"
                  type="date"
                  id="foreign-date"
                  value={selectedDateForeign}
                  onChange={(e) => setSelectedDateForeign(e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="foreign-ts" className="form-label">
                  Шаблон смены
                </label>
                <select
                  className="form-select"
                  id="foreign-ts"
                  value={selectedFreeTS}
                  onChange={(e) => setSelectedFreeTS(e.target.value)}
                >
                  <option value={0}>Не выбрано</option>
                  {dataFreeTS.map((ts) => (
                    <option key={ts.id} value={ts.id}>
                      {ts.start} - {ts.end}. {ts.hours} ч. {ts.station_name}. В
                      ресторане {ts.restaurant_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-12 d-flex flex-wrap gap-2">
                <button className="btn" type="button" onClick={getFreeTS}>
                  Выгрузить шаблоны смен
                </button>
                <button className="btn" type="button" onClick={recordForeignShift}>
                  Записать сотрудника
                </button>
              </div>
              {foreignMessage && <div className="col-12">{foreignMessage}</div>}
            </div>

            <hr />

            <h5 className="mb-3">Скачивание отчёта</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="download-start" className="form-label">
                  Начало периода
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="download-start"
                  value={startDateDownload}
                  onChange={(e) => setStartDateDownload(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="download-end" className="form-label">
                  Конец периода
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="download-end"
                  value={endDateDownload}
                  onChange={(e) => setEndDateDownload(e.target.value)}
                />
              </div>
              <div className="col-md-4 d-flex align-items-end">
                <button className="btn" type="button" onClick={download}>
                  Скачать xlsx
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="row">
        <div className="col-md-12">
        <div
          className="modal fade modal-schedule-chk-day"
          id="ScheduleDayModal"
          tabIndex="-1"
          aria-labelledby="approvalModelLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header justify-content-center">
                <h1 className="modal-title fs-5" id="approvalModelLabel">
                  Информация
                </h1>
              </div>
              <div className="modal-body">
                <div className="schedule-chk-modal-info text-center">
                  <p>
                    Выбранный сотрудник —{" "}
                    <b>{selectedDayUser && getInfoUser(selectedDayUser)}</b>
                  </p>
                  <p>
                    День недели — <b>{weekDays[selectedWeekday]}</b>
                  </p>
                </div>
                {showAddFromDay && (
                  <>
                    <div className="schedule-chk-modal-actions">
                      <select
                        className="form-select"
                        defaultValue={0}
                        onChange={(e) => setSelectedTypeShift(e.target.value)}
                      >
                        <option value="0">Выберите статус дня</option>
                        {openTypeShift.map((typeShift) => (
                          <option key={typeShift.id} value={typeShift.id}>
                            {typeShift.name}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        className="btn"
                        onClick={addShiftOpenScheduleDay}
                      >
                        Записать
                      </button>
                    </div>
                    <div className="schedule-chk-modal-actions">
                      <select
                        className="form-select"
                        defaultValue={0}
                        onChange={(e) => setSelectedInternUser(e.target.value)}
                      >
                        <option value="0">
                          Выберите сотрудника для закрепления
                        </option>
                        {userModal.map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.surname} {user.name}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        className="btn"
                        onClick={addInternShiftScheduleDay}
                      >
                        Закрепить
                      </button>
                    </div>
                  </>
                )}
                {!showAddFromDay && (
                  <div className="text-center mb-2">
                    {getInfoShift(selectedShiftDay)}
                  </div>
                )}
                <div className="schedule-chk-modal-actions">
                  <select
                    className="form-select"
                    value={selectedFreeTS}
                    onChange={(e) => setSelectedFreeTS(e.target.value)}
                  >
                    <option value={0}>Не выбрано</option>
                    {dataFreeTS.map((ts) => (
                      <option key={ts.id} value={ts.id}>
                        {ts.start} - {ts.end}. {ts.hours} ч. {ts.station_name}
                      </option>
                    ))}
                  </select>
                  <button
                    type="button"
                    className="btn"
                    onClick={createShiftDayByTS}
                  >
                    Записать
                  </button>
                </div>
              </div>
              <div className="modal-footer justify-content-center flex-column">
                {!showAddFromDay && (
                  <button
                    type="button"
                    className="btn btn-danger mb-2"
                    onClick={deleteShiftScheduleChk}
                  >
                    Удалить запись
                  </button>
                )}
                <div className="text-center w-100">{modalMessageDay}</div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade modal-schedule-chk-day schedule-grafic-modal"
          id="ScheduleGraficModal"
          tabIndex="-1"
          aria-labelledby="ScheduleGraficModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header justify-content-center flex-column border-0 pb-0">
                <h1 className="modal-title fs-5" id="ScheduleGraficModalLabel">
                  {useServiceNoteFlow
                    ? "Служебная записка — изменение расписания"
                    : "Работа со сменой"}
                </h1>
                {useServiceNoteFlow && (
                  <p className="small text-muted mb-0 mt-1 text-center">
                    Расписание согласовано ТУ. Изменения оформляются через
                    служебную записку.
                  </p>
                )}
              </div>
              <div className="modal-body pt-2">
                <ul
                  className="nav nav-tabs schedule-grafic-modal-tabs mb-3"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${graficModalTab === "create" ? "active" : ""}`}
                      onClick={() => setGraficModalTab("create")}
                    >
                      Запись на смену
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${graficModalTab === "delete" ? "active" : ""}`}
                      onClick={() => setGraficModalTab("delete")}
                    >
                      Удаление
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${graficModalTab === "replace" ? "active" : ""}`}
                      onClick={() => setGraficModalTab("replace")}
                      disabled={!useServiceNoteFlow && !selectedShift}
                    >
                      Заменить сотрудника
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${graficModalTab === "swap" ? "active" : ""}`}
                      onClick={() => setGraficModalTab("swap")}
                      disabled={!useServiceNoteFlow && !selectedShift}
                    >
                      Поменять местами
                    </button>
                  </li>
                </ul>
                {renderGraficModalTabContent()}
                {useServiceNoteFlow && (
                  <div className="mt-3">
                    <label className="form-label small fw-semibold">
                      Причина / комментарий к служебной записке
                    </label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={serviceNoteComment}
                      onChange={(e) => setServiceNoteComment(e.target.value)}
                      placeholder="Опишите причину изменения расписания"
                    />
                  </div>
                )}
              </div>
              <div className="modal-footer justify-content-center flex-column border-0 pt-0">
                {((graficModalTab === "create" ||
                  graficModalTab === "delete") ||
                  useServiceNoteFlow) && (
                  <button
                    type="button"
                    className={`btn mb-2 ${graficModalTab === "delete" && !useServiceNoteFlow ? "btn-danger" : ""}`}
                    onClick={handleGraficModalSubmit}
                    disabled={isGraficModalSubmitDisabled()}
                  >
                    {getGraficModalSubmitLabel()}
                  </button>
                )}
                {!useServiceNoteFlow &&
                  (graficModalTab === "replace" || graficModalTab === "swap") && (
                    <p className="text-muted small text-center mb-2">
                      Замена и обмен сотрудников — через служебную записку после
                      согласования расписания ТУ
                    </p>
                  )}
                <div className="text-center w-100">{modalMessageGrafic}</div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="approvalModal"
          tabIndex="-1"
          aria-labelledby="approvalModelLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header justify-content-center">
                <h1 className="modal-title fs-5" id="approvalModelLabel">
                  Согласование
                </h1>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Этап согласования</label>
                  <select
                    className="form-select"
                    onChange={selectStageApprove}
                    value={userApprove["status_id"]}
                  >
                    <option value="1">Не согласовано</option>
                    <option value="2">На доработке</option>
                    <option value="3">Согласовано</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Комментарий</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    onChange={onChangeCommentApprove}
                    value={userApprove["comment"]}
                  />
                </div>
                <div className="text-center">{approveMessage}</div>
              </div>
              <div className="modal-footer justify-content-center">
                <button type="button" className="btn" onClick={approveSchedule}>
                  Сохранить
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
  function pushTemplateShiftTbody(
    templateShift,
    date,
    startGroup,
    offset,
    groupName,
    start,
    hours,
    end,
    keyText,
  ) {
    return (
      <tr
        key={`ts_${templateShift.id}_${keyText}`}
        onClick={() => selectFieldGrafic(templateShift, null, date)}
        data-bs-toggle="modal"
        data-bs-target="#ScheduleGraficModal"
      >
        {startGroup && (
          <td rowSpan={offset} className="align-items-center">
            {groupName}
          </td>
        )}
        <td>{templateShift.station_name}</td>
        <td className="text-center">Не выбрано</td>
        <td className="text-center">
          {templateShift.start} - {templateShift.end}
        </td>
        {Array.from({ length: start }, (_, i) => (
          <td key={i} scope="col"></td>
        ))}
        {Array.from({ length: hours }, (_, i) => (
          <td key={i} scope="col" className="grafic-hour--empty"></td>
        ))}
        {Array.from({ length: end }, (_, i) => (
          <td key={i} scope="col"></td>
        ))}
      </tr>
    );
  }

  function pushShiftTbody(
    templateShift,
    shift,
    date,
    startGroup,
    offset,
    groupName,
    start,
    hours,
    end,
    KeyText,
  ) {
    return (
      <tr
        key={`shift_${shift.id}_${KeyText}`}
        onClick={() => selectFieldGrafic(templateShift, shift, date)}
        data-bs-toggle="modal"
        data-bs-target="#ScheduleGraficModal"
      >
        {startGroup && (
          <td rowSpan={offset} className="align-items-center">
            {groupName}
          </td>
        )}
        <td>{templateShift.station_name}</td>
        <td className="text-center">
          {shift.user_surname} {shift.user_name} {shift.user_post_name}
        </td>
        <td className="text-center">
          {shift.start} - {shift.end}
        </td>
        {Array.from({ length: start }, (_, i) => (
          <td key={i} scope="col"></td>
        ))}
        {Array.from({ length: hours }, (_, i) => (
          <td key={i} scope="col" className="grafic-hour--filled"></td>
        ))}
        {Array.from({ length: end }, (_, i) => (
          <td key={i} scope="col"></td>
        ))}
      </tr>
    );
  }
};

export default ScheduleChk;

const formatDate = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function getFormattedWeekDates(inputDate) {
  // Создаем копию объекта Date, чтобы не изменять оригинал
  const date = new Date(inputDate);

  // Получаем день недели (0 - воскресенье, 1 - понедельник и т.д.)
  const dayOfWeek = date.getDay();

  // Вычисляем дату понедельника
  const monday = new Date(date);
  monday.setDate(date.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

  // Создаем массив отформатированных дат
  const weekDates = [];

  // Добавляем 7 дней (с понедельника по воскресенье)
  for (let i = 0; i < 7; i++) {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    weekDates.push(formatDate(day));
  }

  return weekDates;
}

function getWeekRange(inputDate) {
  // Создаем копию входной даты, чтобы не изменять оригинал
  const date = new Date(inputDate);

  // Получаем день недели (0 - воскресенье, 1 - понедельник, ..., 6 - суббота)
  const dayOfWeek = date.getDay();

  // Вычисляем разницу между текущим днем и понедельником
  // Если день воскресенье (0), то понедельник был 6 дней назад
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;

  // Вычисляем дату понедельника
  const monday = new Date(date);
  monday.setDate(date.getDate() + diffToMonday);

  // Вычисляем дату воскресенья (понедельник + 6 дней)
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const lastSunday = new Date(monday);
  lastSunday.setDate(monday.getDate() - 1);

  // Возвращаем объект с датами
  return {
    monday: formatDate(monday),
    sunday: formatDate(sunday),
    lastSunday: formatDate(lastSunday),
  };
}

const weekDays = {
  0: "Понедельник",
  1: "Вторник",
  2: "Среда",
  3: "Четверг",
  4: "Пятница",
  5: "Суббота",
  6: "Воскресенье",
};

function formatShortDate(dateString) {
  if (!dateString) return "";
  const parts = dateString.split("-");
  return `${parts[2]}.${parts[1]}`;
}

function getInfoUser(user) {
  return `${user.surname} ${user.name} \n (${user.post_name})`;
}

function getInfoShift(shift) {
  if (shift) {
    if (shift.type_shift_id == 2) {
      return `Закр. за сот. ${shift.start} - ${shift.end} ${shift.station_name}`;
    } else if (shift.hours) {
      return `${shift.start} - ${shift.end} ${shift.station_name}`;
    } else {
      return `${shift.type_shift_name}`;
    }
  }
}

function getRussianWeekday(dateString) {
  const date = new Date(dateString);
  const days = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ];
  return days[date.getDay()];
}

function getISODayNumber(dateString) {
  const date = new Date(dateString);
  const dayNumber = date.getDay(); // 0=воскресенье, 1=понедельник... 6=суббота

  // Преобразуем: понедельник=0, воскресенье=6
  return dayNumber === 0 ? 6 : dayNumber - 1;
}
